var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocUploadPIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 321,
    height: 200,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 320,
    height: 199,
    rx: 11.5,
    fill: "#FBFBFB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 320,
    height: 199,
    rx: 11.5,
    stroke: "#D2D9E7"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 131,
    y: 64,
    width: 87,
    height: 13,
    rx: 6.5,
    fill: "#EEF2F5"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 131,
    y: 97,
    width: 87,
    height: 14,
    rx: 7,
    fill: "#EEF2F5"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 131,
    y: 127,
    width: 58,
    height: 13,
    rx: 6.5,
    fill: "#EEF2F5"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 167,
    width: 289,
    height: 5,
    rx: 2.5,
    fill: "#EEF2F5"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 182,
    width: 289,
    height: 5,
    rx: 2.5,
    fill: "#EEF2F5"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 247,
    y: 127,
    width: 58,
    height: 13,
    rx: 6.5,
    fill: "#EEF2F5"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 247,
    y: 64,
    width: 58,
    height: 13,
    rx: 6.5,
    fill: "#EEF2F5"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 247,
    y: 98,
    width: 58,
    height: 13,
    rx: 6.5,
    fill: "#EEF2F5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 50,
    width: 95,
    height: 106,
    rx: 10,
    fill: "#EEF2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.106 75.192c.594 3.755-2.103 17.44-3.526 23.812H44.39c-1.732-4.287-5.158-13.8-5.01-17.555.149-3.754 6-10.138 8.906-12.861 1.547-2.955 6.309-9.003 12.989-9.56 8.35-.695 27.09 11.472 27.832 16.164Z",
    fill: "#D2D9E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.549 90.14c-2.969-.417-4.577 5.504-5.01 8.516l-2.227 8.169c1.3.638 4.157 1.669 5.196.696 1.299-1.217 5.752-16.86 2.04-17.381Zm-47.724 0c2.968-.417 4.576 5.504 5.01 8.516l2.226 8.169c-1.299.638-4.156 1.669-5.195.696-1.3-1.217-5.752-16.86-2.041-17.381Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.76 108.65V85.51c0-5.538 5.08-9.879 10.967-9.37.727.063 1.459.052 2.182-.034l10.403-1.23c3.896-.462 7.814.686 10.736 3.143 2.858 2.404 4.491 5.833 4.491 9.431v21.2c0 10.031-8.681 18.162-19.39 18.162-10.708 0-19.39-8.131-19.39-18.162Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m38.277 142.034 13.072-12.121H75.65l13.072 12.121L111 150.061v8.466H64.973l.005-.027h-2.956l.005.027H16v-8.466l22.277-8.027Z",
    fill: "#D2D9E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m51.102 130.489-.961-11.353h27.09l-1.443 11.353-7.761 3.537a10.001 10.001 0 0 1-7.946.151l-8.979-3.688Z",
    fill: "#FFFFFE"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 26.22v-14h2.9v14H23Zm5.45 0v-14h2.76l6.96 9.04v-9.04h2.72v14h-2.56l-7.14-9.36v9.36h-2.74Zm18.8 0V14.78h-4.72v-2.56h12.32v2.56h-4.7v11.44h-2.9Zm9.227 0v-14h10.76v2.52h-7.86v3.2h5.18v2.44h-5.18v3.32h7.94v2.52h-10.84Zm12.89 0v-14h6.84c.947 0 1.78.187 2.5.56.734.36 1.3.867 1.7 1.52.413.653.62 1.407.62 2.26 0 .893-.246 1.68-.74 2.36-.493.68-1.153 1.187-1.98 1.52l3.1 5.78h-3.24l-2.74-5.36h-3.16v5.36h-2.9Zm2.9-7.74h3.68c.653 0 1.174-.173 1.56-.52.4-.347.6-.8.6-1.36s-.2-1.013-.6-1.36c-.386-.347-.907-.52-1.56-.52h-3.68v3.76Zm10.674 7.74v-14h2.76l6.96 9.04v-9.04h2.72v14h-2.56l-7.14-9.36v9.36h-2.74Zm13.641 0 5.76-14h3.34l5.7 14h-3.14l-1.42-3.68h-5.78l-1.44 3.68h-3.02Zm5.36-6h4l-2-5.16-2 5.16Zm11.89 6V14.78h-4.72v-2.56h12.32v2.56h-4.7v11.44h-2.9Zm9.227 0v-14h2.9v14h-2.9Zm12.309.22c-1.04 0-2.007-.18-2.9-.54a7.598 7.598 0 0 1-2.36-1.54 7.59 7.59 0 0 1-1.58-2.3 7.184 7.184 0 0 1-.56-2.84 7.04 7.04 0 0 1 .56-2.82 7.277 7.277 0 0 1 1.58-2.3 7.152 7.152 0 0 1 2.36-1.54 7.444 7.444 0 0 1 2.9-.56c1.04 0 2.006.187 2.9.56a6.9 6.9 0 0 1 2.36 1.54 6.891 6.891 0 0 1 1.58 2.3c.373.867.56 1.807.56 2.82s-.187 1.96-.56 2.84a7.17 7.17 0 0 1-1.58 2.3 7.318 7.318 0 0 1-2.36 1.54c-.894.36-1.86.54-2.9.54Zm0-2.66a4.45 4.45 0 0 0 1.76-.34c.533-.24 1-.56 1.4-.96.4-.413.713-.9.94-1.46.226-.56.34-1.16.34-1.8a4.67 4.67 0 0 0-.34-1.8 4.285 4.285 0 0 0-.94-1.44 4.235 4.235 0 0 0-1.4-.96 4.242 4.242 0 0 0-1.76-.36c-.627 0-1.207.12-1.74.36-.534.227-1 .547-1.4.96-.4.4-.714.88-.94 1.44a4.595 4.595 0 0 0-.34 1.78 4.8 4.8 0 0 0 .34 1.82c.226.56.54 1.047.94 1.46.4.4.866.72 1.4.96a4.4 4.4 0 0 0 1.74.34Zm9.409 2.44v-14h2.76l6.96 9.04v-9.04h2.72v14h-2.56l-7.14-9.36v9.36h-2.74Zm13.641 0 5.76-14h3.34l5.7 14h-3.14l-1.42-3.68h-5.78l-1.44 3.68h-3.02Zm5.36-6h4l-2-5.16-2 5.16Zm10.628 6v-14h2.9v11.44h7.66v2.56h-10.56Zm16.582 0v-14h7.02c.92 0 1.727.187 2.42.56.707.373 1.26.893 1.66 1.56.4.653.6 1.413.6 2.28 0 .827-.2 1.567-.6 2.22a4.205 4.205 0 0 1-1.66 1.54c-.706.373-1.513.56-2.42.56h-4.12v5.28h-2.9Zm2.9-7.68h3.8c.627 0 1.127-.173 1.5-.52.387-.347.58-.807.58-1.38 0-.587-.193-1.053-.58-1.4-.373-.347-.873-.52-1.5-.52h-3.8v3.82Zm7.303 7.68 5.76-14h3.34l5.7 14h-3.14l-1.42-3.68h-5.78l-1.44 3.68h-3.02Zm5.36-6h4l-2-5.16-2 5.16Zm15.922 6.2a9.214 9.214 0 0 1-3.32-.62 9.209 9.209 0 0 1-2.88-1.8l1.66-2.08c.813.72 1.593 1.24 2.34 1.56.76.32 1.56.48 2.4.48.586 0 1.093-.067 1.52-.2.426-.147.753-.353.98-.62.24-.267.36-.58.36-.94 0-.48-.174-.847-.52-1.1-.347-.267-.94-.473-1.78-.62l-2.78-.48c-1.187-.2-2.094-.62-2.72-1.26-.614-.64-.92-1.467-.92-2.48 0-.867.22-1.62.66-2.26.453-.64 1.086-1.127 1.9-1.46.826-.347 1.806-.52 2.94-.52 1.026 0 2.046.173 3.06.52a9.149 9.149 0 0 1 2.72 1.44l-1.56 2.16c-1.467-1.12-2.94-1.68-4.42-1.68-.52 0-.974.067-1.36.2-.387.133-.687.32-.9.56-.2.227-.3.5-.3.82 0 .427.153.76.46 1 .306.227.82.4 1.54.52l2.64.44c1.4.227 2.446.673 3.14 1.34.693.653 1.04 1.52 1.04 2.6 0 .907-.24 1.7-.72 2.38-.48.667-1.167 1.187-2.06 1.56-.88.36-1.92.54-3.12.54Zm12.812 0a9.218 9.218 0 0 1-3.32-.62 9.209 9.209 0 0 1-2.88-1.8l1.66-2.08c.814.72 1.593 1.24 2.34 1.56.76.32 1.56.48 2.4.48.587 0 1.093-.067 1.52-.2.427-.147.753-.353.98-.62.24-.267.36-.58.36-.94 0-.48-.173-.847-.52-1.1-.347-.267-.94-.473-1.78-.62l-2.78-.48c-1.187-.2-2.093-.62-2.72-1.26-.613-.64-.92-1.467-.92-2.48 0-.867.22-1.62.66-2.26.453-.64 1.087-1.127 1.9-1.46.827-.347 1.807-.52 2.94-.52 1.027 0 2.047.173 3.06.52a9.136 9.136 0 0 1 2.72 1.44l-1.56 2.16c-1.467-1.12-2.94-1.68-4.42-1.68-.52 0-.973.067-1.36.2-.387.133-.687.32-.9.56-.2.227-.3.5-.3.82 0 .427.153.76.46 1 .307.227.82.4 1.54.52l2.64.44c1.4.227 2.447.673 3.14 1.34.693.653 1.04 1.52 1.04 2.6 0 .907-.24 1.7-.72 2.38-.48.667-1.167 1.187-2.06 1.56-.88.36-1.92.54-3.12.54Zm7.617-.2v-14h7.02c.92 0 1.727.187 2.42.56.707.373 1.26.893 1.66 1.56.4.653.6 1.413.6 2.28 0 .827-.2 1.567-.6 2.22a4.205 4.205 0 0 1-1.66 1.54c-.706.373-1.513.56-2.42.56h-4.12v5.28h-2.9Zm2.9-7.68h3.8c.627 0 1.127-.173 1.5-.52.387-.347.58-.807.58-1.38 0-.587-.193-1.053-.58-1.4-.373-.347-.873-.52-1.5-.52h-3.8v3.82Zm17.574 7.9c-1.04 0-2.007-.18-2.9-.54a7.598 7.598 0 0 1-2.36-1.54 7.59 7.59 0 0 1-1.58-2.3 7.184 7.184 0 0 1-.56-2.84 7.04 7.04 0 0 1 .56-2.82 7.277 7.277 0 0 1 1.58-2.3 7.152 7.152 0 0 1 2.36-1.54 7.444 7.444 0 0 1 2.9-.56c1.04 0 2.006.187 2.9.56a6.9 6.9 0 0 1 2.36 1.54 6.891 6.891 0 0 1 1.58 2.3c.373.867.56 1.807.56 2.82s-.187 1.96-.56 2.84a7.17 7.17 0 0 1-1.58 2.3 7.318 7.318 0 0 1-2.36 1.54c-.894.36-1.86.54-2.9.54Zm0-2.66a4.45 4.45 0 0 0 1.76-.34c.533-.24 1-.56 1.4-.96.4-.413.713-.9.94-1.46.226-.56.34-1.16.34-1.8a4.67 4.67 0 0 0-.34-1.8 4.285 4.285 0 0 0-.94-1.44 4.235 4.235 0 0 0-1.4-.96 4.242 4.242 0 0 0-1.76-.36c-.627 0-1.207.12-1.74.36-.534.227-1 .547-1.4.96-.4.4-.714.88-.94 1.44a4.595 4.595 0 0 0-.34 1.78 4.8 4.8 0 0 0 .34 1.82c.226.56.54 1.047.94 1.46.4.4.866.72 1.4.96a4.4 4.4 0 0 0 1.74.34Zm9.409 2.44v-14h6.84c.947 0 1.78.187 2.5.56.733.36 1.3.867 1.7 1.52.413.653.62 1.407.62 2.26 0 .893-.246 1.68-.74 2.36-.493.68-1.153 1.187-1.98 1.52l3.1 5.78h-3.24l-2.74-5.36h-3.16v5.36h-2.9Zm2.9-7.74h3.68c.653 0 1.174-.173 1.56-.52.4-.347.6-.8.6-1.36s-.2-1.013-.6-1.36c-.386-.347-.907-.52-1.56-.52h-3.68v3.76Zm14.358 7.74V14.78h-4.72v-2.56h12.32v2.56h-4.7v11.44h-2.9ZM1 35h320v2H1z",
    fill: "#D2D9E7"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 50,
    width: 95,
    height: 106,
    rx: 10,
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocUploadPIcon);
export default __webpack_public_path__ + "static/media/doc-upload-p-icon.880ea2b3bd03d3d659a6522c02fc43fc.svg";
export { ForwardRef as ReactComponent };